<div
  class="card"
  [ngClass]="{
    'card-border': variant === 'border',
    'card-borderless': variant === 'borderless',
  }"
  [ngStyle]="mergedStyles()"
>
  <ng-content />
  <!-- Content projection -->
</div>
